import React from "react";
import "./PageStyles.css";

const About = () => {
  return (
    <section className="page-section about-section">
      <h1>About Us</h1>
      <h2>OTTOMUN – Shaping Tomorrow’s Global Citizens</h2>

      <p>
        Founded in 2010, <strong>OTTOMUN (Ottoman Model United Nations)</strong> stands as a pioneer
        in Türkiye’s Model United Nations movement — the first independent high school MUN conference
        in the country and the only organization to expand the experience to younger generations
        through <strong>OTTOMUN Juniors</strong> (since 2011) and <strong>OTTOMUN Kids</strong> (since 2017)
        for grade 4 students.
      </p>

      <p>
        What began as a vision to create a meaningful platform for youth diplomacy has evolved into
        one of Türkiye’s largest and most influential educational simulations, empowering thousands
        of students to think critically, speak confidently, and lead responsibly.
      </p>

      <p>
        For over a decade, OTTOMUN has united bright, curious, and motivated students from across
        Turkey and around the world in an immersive, three-day conference where ideas meet action.
        Here, delegates step into the roles of world leaders and diplomats, debate pressing global
        issues, and craft innovative solutions that mirror the complexity and urgency of real-world
        challenges.
      </p>

      <p>
        At the heart of OTTOMUN lies a commitment to academic excellence, inclusivity, and experiential
        learning. Each year, our diverse committees — guided by an international team of university
        students with extensive MUN and debate experience — encourage delegates to engage in meaningful
        dialogue, develop persuasive arguments, and practice the art of diplomacy.
      </p>

      <p>
        Through this, participants not only sharpen their research, communication, and negotiation
        skills but also gain a deeper understanding of global affairs and civic responsibility.
      </p>

      <p>
        Beyond debate, OTTOMUN fosters personal growth. It provides a stage for young voices to be heard,
        a space for collaboration across cultures, and a community where every delegate is inspired to
        make a difference. With every session, resolution, and conversation, students learn to respect
        different perspectives, approach problems creatively, and discover their own potential as
        global citizens.
      </p>

      <p>
        Over the years, OTTOMUN has welcomed participants from more than <strong>25 nationalities</strong>,
        <strong> 400+ schools</strong>, and over <strong>35,000 students</strong>, each contributing to a legacy
        of intellectual curiosity and global awareness. We continue to grow, innovate, and inspire —
        shaping future leaders who believe that diplomacy, empathy, and knowledge can truly change the world.
      </p>

      <p>
        At OTTOMUN, we don’t just simulate the United Nations — we cultivate the spirit of the UN.
      </p>

      <h2>About Ottomun: Forging the Diplomatic Leaders of Tomorrow</h2>
      <p>
        Welcome to <strong>Ottomun</strong>, where diplomatic journeys begin and global perspectives are born.
        We are not just a Model United Nations conference; we are a pioneering educational movement that has
        been shaping young minds in Türkiye and beyond since 2010.
      </p>

      <p>
        As the first independent high school MUN conference in Turkey, we ignited a passion for global
        affairs among students. A year later, we broke new ground again by launching{" "}
        <strong>OTTOMUN Juniors</strong>, the nation's first independent conference for middle school students.
        And our commitment to nurturing future leaders starts early—we are proud to be the only conference in
        Türkiye conducting <strong>OTTOMUN KIDS</strong> for 4th graders.
      </p>

      <p>
        From the youngest delegates taking their first steps in diplomacy to seasoned high school students
        tackling complex global crises, Ottomun provides an unparalleled, continuous learning pathway.
      </p>

      <h2>A Legacy of Excellence and Impact</h2>
      <ul className="custom-bullet-list">
        <li>
          <strong>Over 23,000 Delegates</strong> inspired to become more aware, educated, and thoughtful global citizens.
        </li>
        <li>
          <strong>542 MUN Committees</strong> simulating the fast-paced, complex world of international diplomacy.
        </li>
        <li>
          <strong>114 Conferences</strong> fostering critical thinking, collaboration, and constructive resolution-building.
        </li>
        <li>
          A vibrant community of <strong>382 Schools</strong> and <strong>26 Nationalities</strong>, creating a truly international network.
        </li>
      </ul>

      <h2>The Ottomun Experience: More Than a Simulation</h2>
      <p>
        An Ottomun conference is a three-day immersion into the heart of global politics. We go beyond the
        gavel and procedure to create a dynamic environment where students don't just learn about diplomacy—
        they live it.
      </p>

      <ul className="custom-bullet-list">
        <li>
          <strong>World-Class, International Staff:</strong> Our committee directors and staff are meticulously
          selected university students from around the globe, bringing their extensive MUN expertise and a passion
          for mentorship to every session.
        </li>
        <li>
          <strong>Unforgettable Academic Rigor:</strong> We offer a diverse portfolio of committees, from General
          Assemblies to specialized crisis simulations, all designed to challenge delegates and reflect the complexity
          of today's world. This is supported by exclusive study guides and resources.
        </li>
        <li>
          <strong>A Stage for Your Voice:</strong> We provide a renowned podium for public speaking, empowering delegates
          to build confidence, articulate their positions, and persuade others.
        </li>
        <li>
          <strong>Individualized Attention:</strong> Our staff is known for a detailed, approachable, and supportive style,
          ensuring every delegate receives the guidance they need to excel.
        </li>
      </ul>

      <h2>Our Mission: To Shape the World</h2>
      <p>
        Our core mission is to raise awareness of the world's most pressing social, political, and economic challenges.
        We equip students with the research, communication, and leadership skills necessary to not only understand these
        issues but to actively devise solutions. By operating in English with a native-speaking academic team, we
        simultaneously enhance our delegates' language proficiency, turning it into a powerful tool for international dialogue.
      </p>

      <h2>Our Vision: A Global Footprint for Peaceful Dialogue</h2>
      <p>
        Building on our academic success stories in Turkey, our vision is to expand Ottomun's unique pedagogical environment
        internationally. We are determined to create a global platform where students from all backgrounds can connect,
        communicate, and collaborate, fostering a spirit of mutual respect and understanding.
      </p>

      <p>
        We believe that by empowering the youth of today with diplomatic skills and a global network, we are actively building
        a more peaceful and cooperative world for tomorrow.
      </p>

      <p className="about-footer">
        Join us at Ottomun. Don't just simulate change. <strong>Create it.</strong>
      </p>


    </section>
  );
};

export default About;
